var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['label label-rouded', _vm.cssClass]},[_c('strong',[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"hidden"},[_vm._v(_vm._s(_vm.score))])])}
var staticRenderFns = []

export { render, staticRenderFns }